import React, { useState, cloneElement } from 'react'
import { Paper, LinearProgress } from '../../Atoms'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'transparent',
    minWidth: 300
  },
  paper: {
    position: 'relative',
    padding: 20,
    minWidth: 300
  },
  progress: {
    width: '100%',
    position: 'absolute',
    left: 0,
    top: 0
  },
  blocker: {
    backgroundColor: '#fff',
    opacity: 0.5,
    width: '100%',
    height: '100%',
    borderRadius: 4,
    position: 'absolute',
    top: 0,
    left: 0
  }
})

const propTypes = {
  /** Use the naming standards. */
  id: PropTypes.string.isRequired,
  /** The content of the component. */
  children: PropTypes.element.isRequired,
  /** Override the styles applied to the component. */
  className: PropTypes.any
}

/**
 * ## FormBox
 *
 * ### Usage:
 *  - Wraps child elements for fast prototyping when using TextFields
 *
 */

const FormBox = props => {
  const { children, className, id } = props

  const classes = useStyles()

  const [loading, setLoader] = useState(false)

  const handleLoader = load => {
    setLoader(load)
  }

  return (
    <div
      id={id}
      data-cid='FormBox-root'
      className={clsx(classes.root, className)}
    >
      <Paper className={classes.paper}>
        {loading ? <LinearProgress className={classes.progress} /> : null}
        {cloneElement(children, { loadLoader: handleLoader.bind(this) })}
        {loading ? <div className={classes.blocker}> </div> : null}
      </Paper>
    </div>
  )
}

FormBox.propTypes = propTypes

export default FormBox
